
// src/components/Dashboard/StatusCard.js
import React from 'react';

const StatusCard = ({ title, value, icon, status }) => {
    const getBorderClass = () => {
        switch (status) {
            case 'success': return 'border-left-success';
            case 'warning': return 'border-left-warning';
            case 'danger': return 'border-left-danger';
            default: return 'border-left-primary';
        }
    };

    const getIconClass = () => {
        switch (status) {
            case 'success': return 'text-success';
            case 'warning': return 'text-warning';
            case 'danger': return 'text-danger';
            default: return 'text-primary';
        }
    };

    return (
        <div className={`status-card ${getBorderClass()}`}>
            <div className={`card-icon ${getIconClass()}`}>
                <i className={`fas ${icon}`}></i>
            </div>
            <div className="card-content">
                <h3>{title}</h3>
                <p className="card-value">{value}</p>
            </div>
        </div>
    );
};

export default StatusCard;